export default {
	components: {

	},
	filters: {
	},
	data() {
		return {

		}
	},
	computed: {

	},
	watch: {

	},
	created() {

	},
	methods: {
		/**
		 * @description 點擊全選分店時，要做的事情
		 * @param {*} checked 全選狀態
		 * @param {*} catchPruducts 使用者已勾選的分店
		 * @param {*} products 所有分店
		 */
		checkAllForIsStoreAdmin(checked, catchPruducts, products) {
			const disableContent = this.findNotIncludePermission(catchPruducts)
			catchPruducts = []
			if (checked) {
				catchPruducts = this.filterProductInMixin(products).map(item => item.id)
			}
			catchPruducts.push(...disableContent)
			return catchPruducts
		},
		/**
		 * @description 判斷讓其是否可以被修改(通常用於disable)
		 */
		disableComputed(id) {
			const permissionObj = this.$store.state.auth.currentUserPermission
			let disableStatus = true
			if (!permissionObj.isStoreAdmin) return false
			if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
				disableStatus = !permissionObj.userGroupStoreIds.includes(id)
			}
			return disableStatus
		},
		/**
		 * 給全選使用的filter分店（通常用於checkbox）
		 */
		notCheckAllInPermission(catchList) {
			const permissionObj = this.$store.state.auth.currentUserPermission
			if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
				catchList = catchList.filter(item => permissionObj.userGroupStoreIds.includes(item))
			}
			return catchList
		},
		/**
		 * @description 過濾可以顯示的分店列表（通常用於下拉）
		 */
		filterProductInMixin(list, type = 'id') {
			try {
				const permissionObj = this.$store.state.auth.currentUserPermission
				if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
					list = list.filter(item => permissionObj.userGroupStoreIds.includes(item[type]))
				}
				return list
			} catch (error) {
				console.error(error.message)
			}
		},
		/**
		 * @description 「找出」不存在於分店管理者中的分店
		 */
		findNotIncludePermission(catchList) {
			const permissionObj = this.$store.state.auth.currentUserPermission
			if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
				catchList = catchList.filter(item => !permissionObj.userGroupStoreIds.includes(item))
			}
			return catchList
		},
		/**
		 * @description 「找出」存在於分店管理者中的分店
		 */
		 findIncludePermission(catchList) {
			const permissionObj = this.$store.state.auth.currentUserPermission
			if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
				catchList = catchList.filter(item => permissionObj.userGroupStoreIds.includes(item))
			}
			return catchList
		},
		/**
		 * @description 把不存在於分店管理者中的分店「塞回去」
		 */
		pushNotIncludePermission(catchList, notIncludeList) {
			for (let i = 0, len = notIncludeList.length; i < len; i++) {
				catchList.push(notIncludeList[i])
			}
			const arrToSet = new Set(catchList); 
			const uniqueArray = [...arrToSet];
			return uniqueArray
		},
		/**
		 * @description 確認checkbox狀態
		 */
		checkboxStatus(catchProducts, allLoactions) {
			let status = true
			const permissionObj = this.$store.state.auth.currentUserPermission
			if (permissionObj.isStoreAdmin && permissionObj.userGroupStoreIds) {
				status = permissionObj.userGroupStoreIds.every(item => catchProducts.includes(item))
			}
			if (!permissionObj.isStoreAdmin) {
				status = catchProducts.length === allLoactions.length
			}
			return status
		}
	}
}